// @material-ui/icons
import PersonIcon from '@material-ui/icons/Person';
import NotificationImportant from '@material-ui/icons/NotificationImportant';
import SettingsApplications from '@material-ui/icons/SettingsApplications';
import SearchIcon from '@material-ui/icons/Search';
import VisibilityIcon from '@material-ui/icons/Visibility';
import LibraryMusicIcon from '@material-ui/icons/LibraryMusic';
// import AlbumIcon from '@material-ui/icons/Album';
import FingerprintIcon from '@material-ui/icons/Fingerprint';

// Routing Components
import Profile from 'views/Profile/Profile.jsx';
import PrivateProfile from 'views/Profile/PrivateProfile.jsx';
import PublicProfile from 'views/Profile/PublicProfile.jsx';
import Discover from '../views/Discover/Discover.jsx';
// import SwipeRecommendations from '../views/Swipe/SwipeRecommendations';
import SwipeCollection from '../views/Swipe/SwipeCollection';
import Fynda from '../views/Fynda/Fynda.jsx';
import Imprint from '../views/Imprint/Imprint.jsx';
import Library from '../views/Library/Library.jsx';
import Notifications from '../views/Notifications/Notifications.jsx';
import Settings from '../views/Settings/Settings.jsx';
import LoaderWhite from '../components/LoaderWhite';
// import Artist from '../views/Artist/ArtistUpload.jsx';
import React from 'react';

export default [
  { path: '/profile', name: 'Profile', icon: PersonIcon, component: Profile },
  {
    path: '/discover',
    name: 'Discover',
    icon: SearchIcon,
    component: Discover,
  },
  { path: '/fynda', name: 'Fynda', icon: VisibilityIcon, component: Fynda },
  {
    path: '/imprint',
    name: 'Imprint',
    icon: FingerprintIcon,
    component: Imprint,
  },
  {
    path: '/library',
    name: 'Library',
    icon: LibraryMusicIcon,
    component: Library,
  },
  // { path: '/artist', name: 'Artist', icon: AlbumIcon, component: Artist },
  {
    path: '/notifications',
    name: 'Notifications',
    icon: NotificationImportant,
    component: Notifications,
  },
  {
    path: '/settings',
    name: 'Settings',
    icon: SettingsApplications,
    component: Settings,
  },
  {
    path: '/my-profile',
    admin: true,
    name: 'My Profile',
    component: PrivateProfile,
  },
  { path: '/user/:id', admin: true, component: PublicProfile },
  {
    path: '/swipe/collection/:type/:index',
    admin: true,
    component: SwipeCollection,
  },
  {
    path: '/swipe/collection/:type',
    admin: true,
    component: SwipeCollection,
  },
  { path: '/', name: 'Home', admin: true, component: () => <LoaderWhite /> },
];
